import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import styled from "styled-components";
import { IconButton } from "@base-ui";
import { extendedSystemStyles } from "@mixins";
import { jsx as _jsx } from "react/jsx-runtime";
export var styledSystemKeys = ["space", "layout", "position", "color", "border"];
export var StyledHolder = styled.div.withConfig({
  displayName: "messagestyles__StyledHolder",
  componentId: "sc-14j5lzv-0"
})(["", "", ""], function (_ref) {
  var theme = _ref.theme,
    open = _ref.open,
    inverted = _ref.inverted,
    type = _ref.type;
  return "\n    padding: ".concat(open ? "10px 20px" : "0 20px", ";\n    height: ").concat(open ? "auto" : 0, ";\n    opacity: ").concat(open ? 1 : 0, ";\n\n    background: ").concat(type === "error" ? theme.colors.V3 : inverted ? theme.colors.P1 : theme.colors.G1, ";\n\n    visibility: ").concat(open ? "visible" : "hidden", ";\n    transition: padding .3s;\n  ");
}, extendedSystemStyles(styledSystemKeys));
export var StyledMessageToggler = styled(function (props) {
  return /*#__PURE__*/_jsx(IconButton, _objectSpread({}, props));
}).withConfig({
  displayName: "messagestyles__StyledMessageToggler",
  componentId: "sc-14j5lzv-1"
})(["", "", ""], function (_ref2) {
  var theme = _ref2.theme,
    icon = _ref2.icon,
    active = _ref2.active;
  return "\n    background: ".concat(icon === "error" && !active ? theme.colors.V3 : "", ";\n    color: ").concat(icon === "error" && !active ? theme.colors.G1 : "", ";\n  ");
}, extendedSystemStyles(styledSystemKeys));